webpackJsonp([263791100135453],{

/***/ 553:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(31);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _AboutCalloutModule = __webpack_require__(854);
	
	var _AboutCalloutModule2 = _interopRequireDefault(_AboutCalloutModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//  Components
	var AboutCallout = function AboutCallout(props) {
	  return _react2.default.createElement(
	    'ul',
	    { className: _AboutCalloutModule2.default.about__callout },
	    _react2.default.createElement(
	      'li',
	      null,
	      _react2.default.createElement(
	        'h3',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          'Get additional information on indicators and ranking approach'
	        )
	      ),
	      _react2.default.createElement(_Button2.default, { href: '/methodology', text: 'View Scorecard Methods' })
	    )
	  );
	};
	
	//  Styles
	exports.default = AboutCallout;
	module.exports = exports['default'];

/***/ }),

/***/ 854:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"about__callout":"src-components-AboutCallout----AboutCallout-module---about__callout---3RNUv"};

/***/ }),

/***/ 579:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AboutCallout = __webpack_require__(553);
	
	var _AboutCallout2 = _interopRequireDefault(_AboutCallout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var About = function About() {
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            'article',
	            null,
	            _react2.default.createElement(
	                'h1',
	                { className: 'title__page' },
	                'About'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'section' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'section__row section__row__2_up' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'section__content section__content__narrow' },
	                        _react2.default.createElement(
	                            'h3',
	                            null,
	                            'The Commonwealth Fund\u2019s ',
	                            _react2.default.createElement(
	                                'em',
	                                null,
	                                '2020 Scorecard on State Health System Performance'
	                            ),
	                            ' assesses all 50 states and the District of Columbia on 49 measures of access to health care, quality of care, service use and costs of care, health outcomes, and income-based health care disparities.'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'section__content section__content__wide section__content__bulleted__regular' },
	                        _react2.default.createElement(
	                            'h3',
	                            null,
	                            'COVID-19'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'The 2020 Scorecard documents state-level variation in U.S. health care performance prior to COVID-19\u2019s emergence. The report draws on the most currently available, comprehensive, state-level data, which unfortunately lags in this rapidly evolving environment. Still, the report provides important state-specific context for discussing the pandemic\u2019s implications.'
	                        ),
	                        _react2.default.createElement(
	                            'h3',
	                            null,
	                            'What\'s new?'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'The 2020 Scorecard introduces new performance measures:',
	                            _react2.default.createElement(
	                                'ul',
	                                null,
	                                _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    'State-based public health spending.'
	                                ),
	                                _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    'Primary care spending among Medicare beneficiaries and those with employer coverage.'
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'Also included are data on racial and ethnic inequity, focusing on the disparity between white people and communities of color for a subset of indicators spanning health care access, quality, and health outcomes. (These data are referenced throughout the report but are not used to calculate state rankings.)'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'For the first time, the 2020 Scorecard also reports price information for health services at a state level (not used in state rankings).'
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(_AboutCallout2.default, null)
	        )
	    );
	};
	
	exports.default = About;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-e4cd6fccc12774a58525.js